export function hasOrderedPackage(agentPackageName: unknown) {
  return String(agentPackageName ?? '').trim().length > 0
}

export function createFamilyNumberRouteLocation(
  iccid: string | string[],
  agentPackageName: unknown
) {
  return {
    name: 'familyNumber',
    params: { iccid },
    query: {
      hasPackage: String(hasOrderedPackage(agentPackageName))
    }
  }
}

export function isFamilyNumberAdditionAllowed(hasPackage: unknown) {
  return hasPackage === 'true'
}
